export default __webpack_public_path__ + "static/media/right.c3ee4024.svg";